import * as React from 'react';

import { PaginationButtonsContainer } from './PaginationButtonsContainer';
import { PaginationContainer } from './PaginationContainer';
import { PaginationSection } from '../../components/Pagination';

export function PaginationSectionContainer() {
  return <PaginationSection pagination={<PaginationContainer />} buttons={<PaginationButtonsContainer />} />;
}
